// * What does it do:
// - Filters a list by a search text: case and accents are ignored, every word of the query must appear in the label

// * Who calls it:
// - Dropdown, ModalTeamSelection

// * Which data is needed:
// - The items, the raw search text and a function that returns the label of an item

// * What comes back:
// - The matching items (all items for an empty query)

function normalizeForSearch(input: string) {
  return input.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
}

export function filterBySearch<T>(items: T[], query: string, getLabel: (item: T) => string): T[] {
  const parts = normalizeForSearch(query)
    .trim()
    .split(/[\s-]+/)
    .filter(Boolean)
  if (parts.length === 0) return items

  return items.filter((item) => {
    const label = normalizeForSearch(getLabel(item))
    return parts.every((part) => label.includes(part))
  })
}
